var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 47,
    viewBox: "0 0 70 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.1,
    height: 46.1,
    fill: "#DFE3E8",
    rx: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A6C",
    d: "M34.4 16.4l-3 13.3H28l3-13.3h3.5zM48.8 25l1.9-5 1 5h-2.9zm3.9 4.8h3.2L53 16.4h-2.9c-.6 0-1.2.4-1.4 1l-5.2 12.4h3.6l.7-2h4.4l.4 2zm-9-4.4c0-3.5-4.8-3.8-4.8-5.2 0-.5.4-1 1.4-1.1 1.2-.2 2.4 0 3.4.5l.6-2.8c-1-.4-2.1-.6-3.2-.6-3.4 0-5.8 1.8-5.8 4.4 0 1.9 1.8 3 3 3.6 1.3.6 1.8 1 1.8 1.6 0 1-1 1.3-2 1.4a6 6 0 01-3.5-1l-.7 3c1.3.5 2.6.7 3.9.7 3.6 0 6-1.8 6-4.6m-14.3-9L24 29.8h-3.7L17.4 19c0-.5-.3-1-.8-1.1-1-.5-2.2-1-3.4-1.2v-.3h6c.7 0 1.4.5 1.5 1.3l1.5 7.7 3.6-9h3.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.94c916dd7a3c6b247e497aa4848a1275.svg";
export { ForwardRef as ReactComponent };